module.exports = __webpack_public_path__ + "img/ES3174.f4988959.png";